export enum AllowableFreightStatusType {
    Oil = 'Oil',
    Oversized = 'Oversized',
    LTL = 'LTL'
}
